@if(_tokenService.getLogin()){
  <div class="orgApp-lp-main-div">
    <mat-toolbar class="orgApp-lp-tb-main orgApp-d-flex orgApp-justify-c-spc-btw">
      <div class="orgApp-d-flex orgApp-lp-tb">
        <div class="orgApp-lp-tb-heading orgApp-d-flex orgApp-align-i-center">
          <div class="orgApp-lp-tb-heading-title">
             <div class="orgApp-d-flex orgApp-align-i-center orgApp-gap-2 orgApp-home-p-logo-wrpr orgApp-home-p-logo-pointer">
              <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 100 100">
                <defs>
                  <linearGradient id="grad1" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" style="stop-color:#006ec4;stop-opacity:1"></stop>
                    <stop offset="100%" style="stop-color:#00aaff;stop-opacity:1"></stop>
                  </linearGradient>
                </defs>
        
                <rect x="10" y="10" width="80" height="80" fill="none" stroke="url(#grad1)" stroke-width="6.5" rx="15" ry="15">
                </rect>
                <rect x="35" y="10" width="28" height="14" fill="url(#grad1)" rx="3" ry="3"></rect>
                <g>
                  <rect x="32" y="41" width="10" height="10" fill="#2c9cd8" stroke="none" rx="5" ry="5"
                    transform="translate(1,1)"></rect>
                  <rect x="48" y="41" width="10" height="10" fill="#6d9dd2" stroke="none" rx="5" ry="5"
                    transform="translate(1,1)"></rect>
                  <rect x="64" y="41" width="10" height="10" fill="#006ec4" stroke="none" rx="5" ry="5"
                    transform="translate(1,1)"></rect>
        
                  <path d="M33,55 h5 a5,5 0 0 1 5,5 v13 h-12 v-13 a5,5 0 0 1 5,-5 z" fill="#006ec4" stroke="none"
                    transform="translate(1,1)"></path>
                  <path d="M49,55 h5 a5,5 0 0 1 5,5 v13 h-12 v-13 a5,5 0 0 1 5,-5 z" fill="#be7a85" stroke="none"
                    transform="translate(1,1)"></path>
                  <path d="M65,55 h5 a5,5 0 0 1 5,5 v13 h-12 v-13 a5,5 0 0 1 5,-5 z" fill="#2c9cd8" stroke="none"
                    transform="translate(1,1)"></path>
                </g>
              </svg>
              <div class="orgApp-home-p-logo">
                rgApp
              </div>
            </div>
            <!-- <img
              src="assets/image/logo.png"
              width="200px"
              height="50px"
              alt="Organization logo"
            /> -->
          </div>
        </div>
  
        <nav class="orgApp-lp-tb-nav" aria-label="Toolbar navigation">
          <div class="orgApp-d-flex orgApp-gap-8 orgApp-justify-c-flex-end">
            @if (isLoadingMenu) {
            <div class="orgApp-d-flex orgApp-gap-32 orgApp-margin-top-24">
              @for (item of [].constructor(5); track item; let i=$index) {
              <ngx-skeleton-loader appearance="line"
                [theme]="{'border-radius':'8px',border:'1px solid #ccc', width: '32px', height: '32px' }"></ngx-skeleton-loader>
              }
            </div>}@else{
            @for(item of filteredMenuItems; track item; let i = $index){
            <div
              class="orgApp-lp-tb-nav-tab-div"
              [ngClass]="{
                active: sharedDataService.activeTab.includes(item.routerLink),
                highlighted:
                  sharedDataService.showDropDown &&
                  item.routerLink == '/configuration'
              }"
            >
              @if(i < filteredMenuItems.length - 1 || item.routerLink !== '/configuration') {<!--the icon should redirect to respective pages if it is not configuration menu-->
              <a
                class="orgApp-lp-tb-nav-tab orgApp-lp-tb-nav-tab-div"
                [routerLink]="item.routerLink"
                (click)="onSelectMenuItem(item)"
              >
                <svg
                  matTooltip="{{ 'toolbar.action.' + item.label | translate }}"
                  matTooltipPosition="above"
                  class="orgApp-lp-tb-list-item-icon orgApp-lp-tb-list-item-icon-gap"
                  width="24"
                  [attr.height]="item.height"
                >
                  <use  [attr.y]="item.label === 'Stream' || item.label === 'Dashboard' ? 2 : null"
                    [attr.xlink:href]="
                      '#' +
                      (sharedDataService.activeTab.includes(item.routerLink)
                        ? item.filledIcon
                        : item.outlinedIcon)
                    "
                  ></use>
                </svg>
              </a>
              } @else{<!--it should not redirect if the icon is configuration icon-->
              <a
                class="orgApp-lp-tb-nav-tab orgApp-lp-tb-nav-tab-div"
                (click)="onSelectMenuItem(item)"
                [ngClass]="{ highlighted: sharedDataService.showDropDown }"
              >
                <svg
                  matTooltip="{{ 'toolbar.action.' + item.label | translate }}"
                  matTooltipPosition="above"
                  class="orgApp-lp-tb-list-item-icon orgApp-lp-tb-list-item-icon-gap"
                  width="24"
                  [attr.height]="item.height"
                >
                  <use [attr.y]="item.label === 'Stream' || item.label === 'Dashboard' ? 2 : null"
                    [attr.xlink:href]="
                      '#' +
                      (sharedDataService.activeTab.includes(item.routerLink)
                        ? item.filledIcon
                        : item.outlinedIcon)
                    "
                  ></use>
                </svg>
              </a>
              }
              @if (item.label === 'Chat' && unreadChatCount > 0) {
              <div class="orgApp-lp-tb-nav-tab-badge">
                {{ formatBadgeCount(unreadChatCount) }}
              </div>
              }
            </div>
            }}
          </div>
        </nav>
      </div>

        <div class="orgApp-gap-16 orgApp-d-flex orgApp-align-i-center orgApp-justify-c-center">
          <div class="orgApp-header-orglogo orgApp-text-center">
            @if(isLogoReady && orgLogo ){
              <img mat-card-sm-image [src]="orgLogo" [fallbackImage]="noOrganizationLogo"  alt="Logo" />
            }
            @else{
              <ngx-skeleton-loader  class="orgApp-org-logo-header-img" appearance="circle"></ngx-skeleton-loader>
            }
          </div>
          <div class="orgapp-header-orgdata">
            <div class="org-organization">{{ orgDetails?.name }}</div>
            <div class="org-locationname">{{ selLocationName  }}</div>
          </div>
        </div>
  
      <div class="orgApp-lp-tb-main-hr orgApp-d-flex">
        <form [formGroup]="filterForm"
          class="orgApp-lp-thf orgApp-lp-custom-class orgApp-d-flex orgApp-gap-24 orgApp-align-i-center"
        >
          <!-- @if( locations && locations.length > 1) {
          <mat-form-field class="orgApp-global-th-locations">
            <mat-select [formControl]="locationControl" (selectionChange)="onLocationChange($event)" #locationSelect>
              <mat-select-trigger>
                <svg width="16" height="16"><use [attr.xlink:href]="locationSelect.panelOpen ? '#location-active' : '#location-inactive'"></use></svg> &nbsp;
                {{ locationControl.value?.locationName }}
              </mat-select-trigger>
              <mat-option *ngFor="let location of locations" [value]="location">
                {{ location.locationName }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          } -->
  
          <!-- Display as text when there is only one location -->
          <!-- @if( locations && locations.length === 1) {
          <div class="orgApp-global-location">
            <svg width="16" height="16"> <use xlink:href="#location-active"></use></svg>
            {{ locations[0].locationName }}
          </div>
          } -->

          <button type="button" mat-fab matTooltip="{{'toolbar.content.help-and-support.tooltip' | translate }}"
            class="orgApp-lp-thf-notification-icon" (click)="showHelpAndSupport({label: 'Help & Support',
            routerLink: 'help-and-support'})" (keydown)="
                        ($event.key === 'Enter' || $event.key === ' ') &&
                          showHelpAndSupport({label: 'Help & Support',
                          routerLink: '/help-and-support'})
                      " tabindex="0">
            <svg [attr.width]="iconWidth" [attr.height]="iconHeight" [attr.viewBox]="iconViewBox"
              class="orgApp-lp-thf-notification-icon-svg">
              <use [attr.xlink:href]="sharedDataService.activeTab === 'help-and-support' ? '#help-enabled' : '#help-disabled'"></use>
              <!-- <use [attr.xlink:href]="'#' + (sharedDataService.activeTab === '/notification-detail' ? activeNotificationIcon : notificationIcon)"></use> -->
            </svg>
          </button>

  
          <!-- <div
            matTooltip="{{ 'toolbar.content.tooltip' | translate }}"
            class="orgApp-lp-thf-search-icon orgApp-lp-tb-main-hr-search-icon"
            (click)="onSearchClick()"
            (keydown)="($event.key === 'Enter' || $event.key === ' ') && onSearchClick()"
            tabindex="0"
            role="button"
            aria-label="Search"
          >
            <svg width="21" fill="none" height="20" viewBox="0 0 21 20">
              <use xlink:href="#header-search"></use>
            </svg>
          </div> -->

          <button
            type="button"
            mat-fab
            matTooltip="{{'toolbar.content.notificationDialog.tooltip' | translate }}"
            class="orgApp-lp-thf-notification-icon"
            (click)="showNotificationsDialog()"
            (keydown)="
              ($event.key === 'Enter' || $event.key === ' ') &&
                showNotificationsDialog()
            "
            tabindex="0"
          >
            <svg
              [attr.width]="iconWidth"
              [attr.height]="iconHeight"
              [attr.viewBox]="iconViewBox"
              class="orgApp-lp-thf-notification-icon-svg"
            >
              <use [attr.xlink:href]="'#' + notificationIcon"></use>
              <use [attr.xlink:href]="'#' + (sharedDataService.activeTab.includes('/notification-detail') ? activeNotificationIcon : notificationIcon)"></use>
            </svg>
            @if (sharedDataService.unreadNotfCount > 0) {
            <div class="orgApp-lp-thf-notification-icon-badge">
              {{ formatBadgeCount(sharedDataService.unreadNotfCount) }}
            </div>
            }
          </button>
          @if (profileImg === undefined) {
            <ngx-skeleton-loader
              [count]="1"
              class="orgApp-d-flex orgApp-align-i-center orgApp-justify-c-center orgApp-header-prof-img"
              appearance="circle">
            </ngx-skeleton-loader>
          }
          @else if (hasProfileImage) {
            <img
              [src]="profileImg"
              width="32px"
              height="32px"
              class="orgApp-lp-thf-profile-image"
              [matMenuTriggerFor]="profileMenu"
              (menuOpened)="onMenuOpened()"
              (menuClosed)="onMenuClosed()"
              [ngClass]="{ highlighted: isHighlighted }"
              (error)="profileImg=''"
              alt="Profile photo" />
          }
          @else {
            <div
              class="orgApp-lp-thf-profile-initials orgApp-d-flex orgApp-align-i-center orgApp-justify-c-center"
              [style.background-color]="getAvatarColour(userName)"
              [matMenuTriggerFor]="profileMenu"
              (menuOpened)="onMenuOpened()"
              (menuClosed)="onMenuClosed()"
              [ngClass]="{ highlighted: isHighlighted }">
              {{ getInitials(userName) }}
            </div>
          }
          <mat-menu
            #profileMenu="matMenu"
            class="orgApp-header-profile-container"
            backdropClass="orgApp-profile-menu"
            overlayPanelClass="orgApp-header-profile-Overlay"
            xPosition="before"
          >
            <button mat-menu-item class="orgApp-header-profile-menu-item" (click)="manageProfile()" routerLink="/manage-profile">
              <svg width="20" height="20">
                <use xlink:href="#user-profile-icon"></use>
              </svg>
              {{ "toolbar.content.profile.action.profile" | translate }}
            </button>
            <button mat-menu-item class="orgApp-header-profile-menu-item" (click)="logout()">
              <svg width="20" height="20">
                <use xlink:href="#user-logout-icon"></use>
              </svg>
              {{ "toolbar.content.profile.action.logout" | translate }}
            </button>
          </mat-menu>
          <mat-form-field class="orgApp-lp-thf-dropdown">
            <mat-select
              [(value)]="selectedLanguage"
              formControlName="language"
              class="orgApp-lp-h-lang-drpdwn"
              panelClass="orgApp-lp-lang-dropdown"
              (selectionChange)="onLangChange($event)"
            >
              @for (option of languages; track option) {
              <mat-option [value]="option.id">{{ option.viewValue }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </form>
      </div>
    </mat-toolbar>
    <app-search-sidebar></app-search-sidebar>
    <app-notification-modal (modalClosed)="onNotificationModalClosed()"></app-notification-modal>
    @if(sharedDataService.showDropDown){
    <div class="orgApp-lp-config-container" #dropdownContainer>
      <app-config-dropdown></app-config-dropdown>
    </div>
    }
  </div>
}
